type CredentialSignInResult = {
  ok?: boolean;
  error?: string | null;
  url?: string | null;
} | null | undefined;

export type CredentialSignInOutcome =
  | "success"
  | "csrf_expired"
  | "failure";

/**
 * NextAuth can return HTTP 200 with `/api/auth/signin?csrf=true` when a
 * credentials request loses the CSRF-cookie race. Treat that response as a
 * failure even though `result.ok` is true, otherwise the UI navigates as if a
 * session had been issued and the middleware simply sends the user to login.
 */
export function classifyCredentialSignInResult(
  result: CredentialSignInResult,
): CredentialSignInOutcome {
  if (result?.url) {
    try {
      const responseUrl = new URL(result.url, "http://localhost");
      if (
        responseUrl.pathname === "/api/auth/signin" &&
        responseUrl.searchParams.get("csrf") === "true"
      ) {
        return "csrf_expired";
      }
      if (responseUrl.pathname === "/api/auth/error") return "failure";
    } catch {
      return "failure";
    }
  }

  return result?.ok && !result.error ? "success" : "failure";
}
